"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var parameters_1 = __importDefault(require("@/config/parameters"));
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super.call(this) || this;
        _this.partnership = null;
        _this.imageHeadersAmount = 4;
        _this.imageHeaderIndex = 1;
        _this.size = 'md';
        return _this;
    }
    Header.prototype.onRouteChange = function () {
        if (this.$route.meta && this.$route.meta.headerCollapse) {
            this.size = 'sm';
        }
        else {
            this.size = 'md';
        }
    };
    Header.prototype.mounted = function () {
        var _this = this;
        this.imagesInterval = setInterval(function () {
            _this.imageHeaderIndex = _this.imageHeaderIndex < _this.imageHeadersAmount ? _this.imageHeaderIndex + 1 : 1;
        }, 5000);
        this.$getPartnershipDataService.request(this.$route.params.partnershipSlug).then(function (response) { return _this.partnership = response; }, function (error) {
            _this.$router.push({ name: 'error', params: { code: error.response.status } });
        });
    };
    Header.prototype.getPartnershipImage = function (index) {
        var _a;
        return parameters_1.default.cdn.host + "/partnership/" + ((_a = this.partnership) === null || _a === void 0 ? void 0 : _a.slug) + "/carousel_land_header_" + index + ".jpg";
    };
    Header.prototype.unmounted = function () {
        clearInterval(this.imagesInterval);
    };
    __decorate([
        vue_property_decorator_1.Watch('$route')
    ], Header.prototype, "onRouteChange", null);
    Header = __decorate([
        vue_property_decorator_1.Component({
            name: 'Header'
        })
    ], Header);
    return Header;
}(vue_1.default));
exports.default = Header;
